(() => {
  function mount(root) {
    if (root.dataset.guideReady) return;
    const details = root.querySelector('.co2-guide-contents');
    const nav = details.querySelector('nav');
    const links = [...nav.querySelectorAll('a')];
    const headings = links.map(a => root.querySelector(a.getAttribute('href')));
    if (headings.some(h => !h)) return;
    root.dataset.guideReady = 'true';
    const desktop = window.matchMedia('(min-width:1100px)');
    const resize = () => { details.open = desktop.matches; };
    resize(); desktop.addEventListener('change', resize);
    details.querySelector('summary').addEventListener('click', event => { if (desktop.matches) event.preventDefault(); });
    nav.addEventListener('click', event => {
      const link = event.target.closest('a'); if (!link) return;
      const heading = root.querySelector(link.getAttribute('href')); if (!heading) return;
      event.preventDefault(); if (!desktop.matches) details.open = false;
      history.pushState(null, '', link.getAttribute('href'));
      heading.scrollIntoView({block:'start'}); heading.setAttribute('tabindex','-1'); heading.focus({preventScroll:true});
    });
    let pending = false;
    const update = () => { pending = false; let current = 0;
      headings.forEach((h, i) => { if (h.getBoundingClientRect().top <= 160) current = i; });
      links.forEach((a, i) => { if (i === current) a.setAttribute('aria-current','location'); else a.removeAttribute('aria-current'); });
    };
    const scroll = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', scroll, {passive:true}); update();
    const target = headings.find(h => '#' + h.id === location.hash);
    if (target) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
    const cleanup = event => { if (!event.target.contains(root)) return;
      window.removeEventListener('scroll', scroll); desktop.removeEventListener('change', resize);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  }
  const init = () => document.querySelectorAll('[data-calculator-guide]').forEach(mount);
  init(); document.addEventListener('shopify:section:load', init);
})();
